import React, { Component } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import jwtDecode from 'jwt-decode';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import MainScreen from './MainScreen';

import moment from 'moment';
import mixpanel from 'mixpanel-browser';

import firebase from "firebase";
// Required for side-effects
require("firebase/firestore");

// Hmm, this feels very not good RE: React
firebase.initializeApp({
  apiKey: 'AIzaSyAUPIzKdGeA4xyQAUjbo6Zg1pQ6REF0sPY',
  authDomain: 'btwb-thewire.firebaseapp.com',
  projectId: 'btwb-thewire'
});

const db = firebase.firestore();
const ROUTE_CHANGE_DUR = 500;
const namespace = 'urn:x-cast:com.google.cast.mainbus.messsagingMaster';
let apiInterval = null;

// globo tracks
let tracks = [];

mixpanel.init('8c8da67d820de832e4c293af2ffde0eb');

// <App> is wrapped withRouter to provide location at any given time
// This is necessary to provide <Switch> with it's actual location (vs context)
// See here for more info: https://medium.com/@pshrmn/a-shallow-dive-into-react-router-v4-animated-transitions-4b73f634992a
class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      visible: 'leaderboard',
      gym: null,
      tracks: [],
      wrongCounter: 0,
      recentWorkout: []
    }

    this.changeRoute = this.changeRoute.bind(this);
    this.updateTracks = this.updateTracks.bind(this);
    this.checkForKey = this.checkForKey.bind(this);

  }

  // Go to top of page on transition
  handleRouteChange () {
    setTimeout(() => {
      window.scrollTo(0,0);
    }, ROUTE_CHANGE_DUR / 2);
  };

  changeRoute (loc) {
    this.setState({
      visible: loc
    }, () => {

    })
  }

  updateTracks(tracksArray, context) {
    if(!tracksArray) tracksArray = [];
    this.setState({
      tracks: tracksArray
    }, () => {
      this.handleGymId(this.state.gymID);
      if(context) context.sendCustomMessage(namespace, undefined, 'tracksReceived:' + this.state.tracks.join(','));
    })
  }

  handleGymId(id, contxt) {
    const self = this;
    
    if(!id || typeof id !== "string") {
      if(this.state.gymID) {
        id = this.state.gymID;
      } else {
        return;
      }
    }

    let yesterday = moment().subtract(1, 'days').startOf('day');
    let tomorrow = moment().add(1, 'days').startOf('day');

    const gym = db
      .collection('wodscreen.v2018.gyms')
      .doc(id)
      .get()
      .then((gym) => {
        let ourGym = gym.data();
        self.setState({
          gym: ourGym,
          gymID: id
        });
      });

    const getOurLeaderboard = (track_id, gym_id, idx) => {
      db
        .collection('wodscreen.v2018.gyms')
        .doc(gym_id)
        .collection('workout_sessions')
        .where('track_event_id', '==', track_id)
        .where('rxd', '==', true)
        .where('member_gender', '==', 'Male')
        .orderBy('score_order', 'desc')
        .limit(10)
        .onSnapshot((snapshot) => {

          let leaderboards;
          let holdingPattern = [];
          if(!self.state.Males) {
            leaderboards = [];
          } else {
            leaderboards = self.state.Males;
          }

          snapshot.forEach((doc) => {
            if(!doc.exists) return;
            return holdingPattern.push(doc.data());
          })

          leaderboards[idx] = holdingPattern;

          self.setState({
            Males: leaderboards
          })
        });

        db
        .collection('wodscreen.v2018.gyms')
        .doc(gym_id)
        .collection('workout_sessions')
        .where('track_event_id', '==', track_id)
        .where('member_gender', '==', 'Female')
        .where('rxd', '==', true)
        .orderBy('score_order', 'desc')
        .limit(10)
        .onSnapshot((snapshot) => {

          let leaderboards;
          let holdingPattern = [];
          if(!self.state.Females) {
            leaderboards = [];
          } else {
            leaderboards = self.state.Females;
          }

          snapshot.forEach((doc) => {
            if(!doc.exists) return;
            return holdingPattern.push(doc.data());
          });

          leaderboards[idx] = holdingPattern;

          self.setState({
            Females: leaderboards
          });
        });
    }


    const gymEvent = (yesterdayArg, tomorrowArg) => {
      if(!yesterdayArg) yesterdayArg = new Date(moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DD'));
      if(!tomorrowArg) tomorrowArg = new Date(moment().add(1, 'days').startOf('day').format('YYYY-MM-DD'));

      db
        .collection('wodscreen.v2018.gyms')
        .doc(id)
        .collection('track_events')
        .where('event_date', '>', yesterdayArg)
        .where('event_date', '<', tomorrowArg)
        .orderBy('event_date', 'desc')
        .limit(10)
        .onSnapshot((snapshot) => {
          let docs = snapshot.docs;
          let storedData = [];

          docs.map((doc, idx) => {
            let data = doc.data();

            // filter out unselected track
            if(self.state.tracks.length > 0) {
              if(self.state.tracks.indexOf(data.track_id.toString()) === -1) {
                return;
              }

            }

            return storedData.push(data);
          });

          storedData = _.sortBy(storedData, ['position', 'id']);

          // if Today's a rest day
          if(!storedData[0] || storedData[0].task_type === 'Task::RestDay') {
            if(this.state.wrongCounter >= 3) {
              console.log('failsafe');
              return this.setState({
                recentWorkout: [{}],
                Males: [],
                Females: []
              }, () => {
                return this.setState({wrongCounter: 0})
              });
            }

            storedData = [];
            let yesterdayJS = new Date(yesterday.subtract(1, 'days').format('YYYY-MM-DD'));
            let tomorrowJS = new Date(tomorrow.subtract(1, 'days').format('YYYY-MM-DD'));
            // return;
            return this.setState({
              wrongCounter: this.state.wrongCounter + 1,

            }, () => {
              setTimeout(() => {
                return gymEvent(yesterdayJS, tomorrowJS);
              }, 2000);
              return;
            })
          }

          return self.setState({
            recentWorkout: storedData,
            wrongCounter: 0
          }, () => {

            this.state.recentWorkout.map((track, idx) => {
              return getOurLeaderboard(track.id, id, idx);
            });
          })
        });
        
    }

    gymEvent();

    return setInterval(() => {
      mixpanel.track('Cast refresh screen', {
        screen: 'Leaderboard',
        type: 'Receiver',
        gym: id
      });
      
      yesterday = moment().subtract(1, 'days').startOf('day');
      tomorrow = moment().add(1, 'days').startOf('day');
      gymEvent();
    }, 1200000)
  }

  checkForKey() {

    if(!window.location.search) return;
    let jwtToken = window.location.search.split('?jwt=');

    if(!jwtToken[1]) return;

    const ourCodes = jwtDecode(jwtToken[1]);
    if(!ourCodes.scopes) return;
    let ourKey = ourCodes.scopes[0];
    this.setState({working: true});
    this.handleGymId(ourKey);

    mixpanel.track('Cast ID set', {
      screen: 'Leaderboard',
      type: 'Receiver',
      gym: ourKey
    });
  }

  componentDidMount() {
    // this.handleGymId('_z63'); 
    //_d6a3
    this.checkForKey();
  }

  render() {

   return (
    <div className="App">

      {this.state.gym ? 
        (<Header location={this.state.visible} gym={this.state.gym} />) : ('')
      }

      <TransitionGroup className="App__body">
        <CSSTransition key={this.props.location.key} onEnter={this.handleRouteChange} timeout={ROUTE_CHANGE_DUR} classNames="App__route--fade" appear>
          <div className="wrapper">
            {(this.state.Males && this.state.Females) ? 
              (
                <MainScreen 
                  males={this.state.Males}
                  females={this.state.Females} 
                  empty={this.state.empty}
                  recentWorkout={this.state.recentWorkout} />
              ) : (
              <div>
                {this.state.working ? (
                  <h1>Setting up your WODscreen now!</h1>
                ) : (
                  <h1>Click <a href={'https://www.beyondthewhiteboard.com/session/jwt/_coaching_team_1?to=' + window.location.href}>here</a> to get your gym ID</h1>
                )}
              </div>
            )}
          </div>
        </CSSTransition>
      </TransitionGroup>

      {this.state.gym ? 
        (<Footer location={this.state.visible} gym={this.state.gym} />) : ('')
      }

    </div>
    );
  }
}
export default withRouter(App);


// WEBPACK FOOTER //
// ./src/containers/App.js